module.exports = __webpack_public_path__ + "img/banner_left.82f3c603.jpg";